import type { ComponentTheme } from '../types/component-theme';

import { LoadingDotsAnimations } from './constants/loading-dots-animations';
import { LoadingDotsVariants } from './constants/loading-dots-variants';
import { ThemeVariants } from './constants/theme-variants';

export default {
    slots: {
        root:
            'inline-flex items-center gap-[0.45rem] [&>span]:size-2 [&>span]:rounded-full ' +
            '[&>span:nth-child(1)]:[animation-delay:0s]'
    },
    variants: {
        variant: {
            [LoadingDotsVariants.Accent]: {
                root: '[&>span]:bg-(--accent-solid,var(--color-blue-violet-400))'
            },
            [LoadingDotsVariants.Gradient]: {
                root: '[&>span]:bg-linear-to-br [&>span]:from-violet-400 [&>span]:to-blue-400'
            }
        },
        animation: {
            [LoadingDotsAnimations.Pulse]: {
                root:
                    '[&>span]:animate-loading-dot-pulse [&>span:nth-child(2)]:[animation-delay:0.4s] ' +
                    '[&>span:nth-child(3)]:[animation-delay:0.8s]'
            },
            [LoadingDotsAnimations.Bounce]: {
                root:
                    '[&>span]:animate-loading-dot-bounce [&>span:nth-child(2)]:[animation-delay:0.18s] ' +
                    '[&>span:nth-child(3)]:[animation-delay:0.36s]'
            }
        }
    },
    compoundVariants: [
        {
            variant: LoadingDotsVariants.Accent,
            theme: ThemeVariants.Dark,
            class: { root: '[&>span]:bg-slate-200' }
        },
        {
            variant: LoadingDotsVariants.Gradient,
            theme: ThemeVariants.Dark,
            class: { root: '[&>span]:shadow-[0_0_0.625rem_var(--progress-glow)]' }
        },
        {
            variant: LoadingDotsVariants.Gradient,
            theme: ThemeVariants.Light,
            class: { root: '[&>span]:shadow-[0_0_0.5rem_var(--progress-glow)]' }
        }
    ]
} satisfies ComponentTheme;
